import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { initialOnlyMySelectionFilter } from "./FilterTypes/OnlyMySelectionFilterType";

const OnlyMySelectionFilter = () => {
  const title = RESX.GeneralLabels.DisplayMySelection;

  const { register, setInitialValue } = useContext(FilterContext);
  register("onlyMySelection", {
    getTitle: () => title,
    renderSelection: () => <></>,
    hasValue: (filter) => filter.showOnlyMySelection,
    reset: () => initialOnlyMySelectionFilter,
    areEqual: (a, b) => a.showOnlyMySelection === b.showOnlyMySelection
  });
  useEffect(() => {
    setInitialValue("onlyMySelection", initialOnlyMySelectionFilter);
  }, []);

  return null;
};

export default OnlyMySelectionFilter;